import { testimonials } from "@/mocks/communityData";

const avatarTone: Record<string, string> = {
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  accent: "bg-accent-500",
};

function Stars({ count }: { count: number }) {
  return (
    <span className="flex items-center gap-0.5 text-accent-500" aria-label={count + " 星好评"}>
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={"text-sm " + (i < count ? "ri-star-fill" : "ri-star-line text-background-300")}></i>
      ))}
    </span>
  );
}

export default function Voices() {
  return (
    <section aria-label="网友口碑评价" className="w-full bg-background-100 py-16 md:py-24">
      <div className="container-x">
        <div className="text-center">
          <span className="tag-primary mx-auto"><i className="ri-heart-3-fill"></i>Community Love</span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            为什么瓜友都<span className="text-primary-500">不想走</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            评论区里吵吵闹闹，心里却越来越暖。来看看老瓜友们的真实感受，也欢迎你加入他们的日常。
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="card relative flex flex-col p-6 transition-all duration-300 hover:-translate-y-1 hover:ring-accent-200"
            >
              <i className="ri-double-quotes-l absolute right-5 top-4 text-4xl text-background-200"></i>
              <Stars count={t.stars} />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className={"flex h-10 w-10 items-center justify-center rounded-full font-bold text-background-50 " + avatarTone[t.avatarHue]}>
                  {t.name[0]}
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* quick stats strip */}
        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-2xl bg-gradient-to-r from-primary-500 via-primary-600 to-accent-500 px-8 py-6 sm:flex-row">
          <div className="flex items-center gap-3 text-background-50">
            <i className="ri-thumb-up-fill text-3xl"></i>
            <p className="text-sm font-medium leading-relaxed">
              <strong className="text-base font-black">97.6% 瓜友认为这里氛围友好</strong>
              <span className="block opacity-90">真实评价来自持续运营的内容审核与正向互动体系。</span>
            </p>
          </div>
          <a href="#plaza" className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-6 py-2.5 text-sm font-bold text-primary-700 transition-all hover:-translate-y-0.5 hover:bg-background-100">
            我也来唠两句 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}